// Rooms page
if($('.room-modal').length) {
  // Set room id on modal for access in AJAX call
  $('.room-trigger').click(function(e) {
    $('.room-modal').attr('data-room-id', e.currentTarget.dataset.roomId);
  })

  // Initialize modal
  $(".room-modal").iziModal({
    closeButton: true,
    onOpening: function(modal){
   
      modal.startLoading();
      const id = modal.$element[0].dataset.roomId;

      // Get language from cookie
      // const re = new RegExp('i18n' + "=([^;]+)");
      // const value = re.exec(document.cookie);
      // const lang = (value != null) ? unescape(value[1]) : 'en';

      // Set path with language
      const path = '/room/' + id;

      $.get(path, function(data) {
          $(".room-modal .iziModal-content").html(data);
          modal.stopLoading();
      });
    }
  });
}


// WEBPACK FOOTER //
// ./public/javascripts/modules/roomsModal.js